import React, { useState } from 'react';
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { useAuth } from '../context/authContext';
import Login from '../views/login/login';
import AcessoNegado from '../views/acesso-negado/acesso-negado';
import PaginaNaoEncontrada from '../views/pagina-nao-encontrada/pagina-nao-encontrada';
import NavBar from '../components/navbar/navbar';
import EsqueceuSenha from '../views/usuario/esqueceu-senha';
import AlterarSenha from '../views/usuario/alterar-senha';
import LoadingPage from '../views/loading/loading';
import Home from '../views/home/home';
import Contatos from '../views/contatos/contatos';
import Footer from '../components/footer2/footer';
import DelayedSuspense from './DelayedSuspense';

import MinhasSolicitacoes from '../views/helpdesk/lista-chamados/minhas-solicitacoes';
import AberturaChamado from '../views/helpdesk/abertura/abertura-chamado';
import { VisualizarChamado } from '../views/helpdesk/visualizacao/visualizar-chamado';
import Assinatura from '../views/helpdesk/solucoes/AssinaturaEmail';
import NpsForm from '../views/nps/Criar-Nps';
import Siderbar from '../components/sidebar/sidebar';
import Clients from '../views/clients/Clients';
import DashboardNps from '../views/nps/dashboard/dashboard';
import RelatoriosNps from '../views/nps/relatorios/relatorios';
import Pedidos from '../views/pedidos/pedidos';
import MotoristaList from '../views/motorista/MotoristaList';
import DriverAssistantList from '../views/ajudantes/DriverAssistantList';
const MeusDados = React.lazy(() => import('../views/meusdados/meusdados'))

function Router() {
    const { authenticated, user } = useAuth();

    const PrivateRoute = () => {
        document.title = "Suporte | Distribuidora York"
        return authenticated === true ?
            <div>
                <NavBar />
                <div className='pt-[14px]'>
                    <Outlet />
                </div>
                <Footer />
            </div>
            :
            <Navigate to="/login" />;
    };

    const NpsRouter = () => {
        document.title = "NPS | Distribuidora York"
        const [isOpen, setIsOpen] = useState(false);

        return authenticated === true && user.roles.includes("NPS") ?
            <div className="flex h-screen overflow-hidden">
                <Siderbar open={isOpen} setOpen={setIsOpen} />
                <div style={{ zoom: '0.8' }} className="flex-1 overflow-auto">
                    <div className="bg-white shadow-sm p-4 flex items-center md:hidden">
                        <button id="openSidebar" className="text-gray-500 mr-4" onClick={() => setIsOpen(true)}>
                            <i className="fas fa-bars"></i>
                        </button>
                        <h1 className="font-bold text-lg">{ }</h1>
                    </div>
                    <div className="p-6">
                        <div className="flex justify-between items-center mb-6">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
            :
            <Navigate to="/login" />;
    };

    const NotAuthenticatedRoute = () => {
        document.title = "Suporte | Distribuidora York"
        return authenticated === false ?
            <Outlet /> : <Navigate to="/" />;
    };

    return (
        <BrowserRouter>
            <DelayedSuspense fallback={<LoadingPage />}>
                <Routes>
                    <Route path="/acesso-negado" element={<AcessoNegado />} />
                    <Route path="/contatos" element={<Contatos />} />
                    <Route path='/*' element={<PaginaNaoEncontrada />} />
                    <Route path="/" element={<PrivateRoute />}>
                        <Route path="/dados" element={<MeusDados />} />
                        <Route path="/nps" element={<NpsForm />} />
                        <Route path="/minhas-solicitacoes" element={<MinhasSolicitacoes />} />
                        <Route path="/assinatura-de-email" element={<Assinatura />} />
                        <Route path="/solicitacao" element={<AberturaChamado />} />
                        <Route path="/inicio" element={<Home />} />
                        <Route path="/" element={<Home />} />
                        <Route path="/minhas-solicitacoes/ticket/:calledTicket" element={<VisualizarChamado />} />
                    </Route>
                    <Route path="/nps" element={<NpsRouter />}>
                        <Route path="/nps/dashboard" element={<DashboardNps />} />
                        <Route path="/nps/nova-avaliacao" element={<NpsForm />} />
                        <Route path="/nps/nova-avaliacao/:branchCode/:clientCode/:idOrder" element={<NpsForm />} />
                        <Route path="/nps/clientes" element={<Clients />} />
                        <Route path="/nps/consulta" element={<RelatoriosNps />} />
                        <Route path="/nps/clientes" element={<Clients />} />
                        <Route path="/nps/motoristas" element={<MotoristaList />} />
                        <Route path="/nps/ajudantes-motoristas" element={<DriverAssistantList />} />
                        <Route path="/nps/pedidos" element={<Pedidos />} />
                    </Route>
                    <Route path="/" element={<NotAuthenticatedRoute />}>
                        <Route path="/login" element={<Login />} />
                        <Route path="/solicitar-nova-senha" element={<EsqueceuSenha />} />
                        <Route path="/modificar-senha/:id/:codigo" element={<AlterarSenha />} />
                    </Route>
                </Routes>
            </DelayedSuspense>
        </BrowserRouter>
    )
}

export default Router;